import {
    CheckCircleOutlined,
    CheckCircleTwoTone,
    CloseCircleTwoTone,
    InfoCircleTwoTone,
    WarningTwoTone
} from '@ant-design/icons';
import { Badge, Button, Card, Checkbox, Col, message, Modal, Row, Spin, Tooltip } from 'antd';
import { Component } from 'react';
import { connect } from "react-redux";
import { updateLoaderState } from '../../../redux_actions/c240_loader.action';
import { initPreviewForScan } from "../../../redux_actions/preview_status.action";

import { get_response } from "../../../helper/request";
import { C240PromptType } from "../../../utils/const";

function SessionRestoreNotificationComponent(props) {
    let stateRestoreComponent = <div></div>;

    if (props.scannerStateRestoreStatus.msgType === "INFO") {
        stateRestoreComponent = <Row>
            <InfoCircleTwoTone twoToneColor={"#F8C471"} /> {"   " + props.scannerStateRestoreStatus.msg}
        </Row>
    } else if (props.scannerStateRestoreStatus.msgType === "WARN") {
        stateRestoreComponent = <Row>
            <Row><WarningTwoTone twoToneColor={"#E7D928"}/> {"   " + props.scannerStateRestoreStatus.msg}</Row>
        </Row>

    } else if (props.scannerStateRestoreStatus.msgType === "SUCCESS") {
        stateRestoreComponent = <Row>
            <Row><CheckCircleTwoTone twoToneColor={"#26A65B"} />{"  " + props.scannerStateRestoreStatus.msg}</Row>
        </Row>
    } else if (props.scannerStateRestoreStatus.msgType === "ERROR") {
        stateRestoreComponent = <Row>
            <CloseCircleTwoTone twoToneColor={"#C70039"} />{"  " + props.scannerStateRestoreStatus.msg}
        </Row>
    }

    return <Col>
        {stateRestoreComponent}
        <br/>
        {props.dataRestored && props.scannerStateRestoreStatus.msgType != "ERROR" ? 
            <Row>
                <Button style={{background: "#F32013", borderColor: "#CA0B00"}} type="primary"
                        onClick={props.resetPersistedQueueState} size={"large"}>Reset Queued Tasks</Button>
            </Row> : null
        }
    </Col>

}

function OpenGatePromptComponent(props) {
    return (<Row>
        {!props.deletedPreviousData && <SessionRestoreNotificationComponent {...props} />}
        {/*<br/>*/}
        {<Spin spinning={!props.dataRestored} tip={props.restoreProgress}/>}
        {/*(<><Row>Click to Open the Gate</Row><Row>This will allow you to insert / remove slides.</Row></>)*/}
        {/*}*/}
        {/*<br/>*/}
            {/* was added when we were recoding entire rack video and processing at the end */}
            {/* <Row style={{ color: "gray" }}>
                <Row>After the gate opens, try to close gate within 30 minutes.</Row>
                <Row>If it might take more than 30 minutes to prepare the Cassettes, don't Open Gate now,</Row>
                <Row>first prepare Cassettes, then Open Gate, load the Cassettes and then Close the Gate.</Row>
            </Row> */}
    </Row>);
}

class InSlideState extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        if (this.props.red){
            return <Badge color="red" />;
        }else{
            return <Badge color="grey" />;
        }
    }
}


class CassetteBarcodeState extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let cassette_barcode_state = [];
        if (this.props.barcodeTaken === true) {
            cassette_barcode_state.push(<Badge key={"0"} status="success" />);
        } else {
            cassette_barcode_state.push(<Badge key={"1"} status="default" />);
        }
        return cassette_barcode_state;
    }
}

class GatePrompt extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadings:this.props.loadings,
            listOfRemovedTasks : [],            
            restoredPreviousData: false,
            restoreProgress: "0.0",
            scannerStateRestoreStatus: {
                msg: "Restoring previous data, please wait...",
                msgType: "INFO"
            },
            deletedPreviousData: false,
            takeAllBarcodes: false,
            queueAllSlidesForPreviews: false,
            queueAllSlidesForScans: false
        }
        this.scannerStateRestoreStatusPoller = null;
    }

    componentDidMount = () => {
        this.getStatusOfRestoredState();
        if (this.props.prompt === C240PromptType.REMOVED_TASKS_PROMPT){
            let _listOfRemovedTasks = this.state.listOfRemovedTasks
            this.props.removedtasks.map((cassette) => {
                _listOfRemovedTasks.push("R"+cassette["rack"]+"T"+cassette["tray"]+"S"+cassette["slide"])
            })
            this.setState({
                listOfRemovedTasks: _listOfRemovedTasks
            });
        }

        this.scannerStateRestoreStatusPoller = setInterval(this.getStatusOfRestoredState, 3000);
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.previews === undefined 
            && this.props.previews) {
            this.props.dispatch(initPreviewForScan());
        }
    }

    componentWillUnmount = () => {
        clearInterval(this.scannerStateRestoreStatusPoller);
    }

    closePrompt = (e) => {
        e.stopPropagation()
        if (this.props.prompt === C240PromptType.OPEN_GATE_PROMPT) {
            this.props.continueQueuedScans();
        } else if (this.props.prompt === C240PromptType.CLOSE_GATE_PROMPT) {
            this.props.closeGate(this.state.takeAllBarcodes, this.state.queueAllSlidesForPreviews, this.state.queueAllSlidesForScans, this.props.preventLoaderMovement);
        } else if (this.props.prompt === C240PromptType.REMOVED_TASKS_PROMPT) {
            this.props.removedTaskConfirmation();
        }
    }

    isPromptBtnDisabled = (prompt) => {
        if (prompt === C240PromptType.OPEN_GATE_PROMPT) {
            return !this.state.restoredPreviousData || this.props.loadings["user_interaction_start"];
        } else if (prompt === C240PromptType.CLOSE_GATE_PROMPT) {
            return this.props.loadings["user_interaction_end"];
        }
        return false;
    }

    getStatusOfRestoredState = (callback=null) => {
        let url = `/server/scano/1/api~hts~get_state_restore_status/`;
        get_response(url)
            .then(response => {
                let shouldDisplay = response.data["shouldDisplay"];
                let scannerState = response.data["ScannerState"];
                let restoreProgress = response.data["restoreProgress"];

                if (shouldDisplay === "false") {
                    // duplicate call, ignore and unblock open gate button.
                    this.setState({restoredPreviousData: true, scannerStateRestoreStatus: {
                        msg: "",
                        msgType: ""
                    }});

                    if(this.scannerStateRestoreStatusPoller !== null) {
                        clearInterval(this.scannerStateRestoreStatusPoller);
                    }

                    return;
                }

                if(scannerState === "INITIAL") {
                    this.setState({restoreProgress: restoreProgress});
                    return;
                }

                this.setState({restoredPreviousData: true});

                if(scannerState === "SESSION_RESTORE_NA_ON_THIS_DEVICE") {
                    this.setState({scannerStateRestoreStatus: {msg: "Session restore not applicable on this device", msgType: "INFO"}});
                }
                if(scannerState === "SUCCESSFULLY_RESTORED_SESSION") {
                    this.setState({scannerStateRestoreStatus: {msg: "Successfully restored previous session data.", msgType: "SUCCESS"}});
                }
                if(scannerState === "FAILED_TO_RESTORE_SESSION") {
                    this.setState({scannerStateRestoreStatus: {msg: "Couldn't restore previous session data.", msgType: "ERROR"}});
                }
                if(scannerState === "FAILED_TO_RESTORE_TASK_QUEUE") {
                    this.setState({scannerStateRestoreStatus: {msg: "Couldn't to restore task queue, you might need to queue the scans again.", msgType: "WARN"}});
                }
                if(scannerState === "DELETED_BY_USER") {
                    this.setState({deletedPreviousData: true});
                }
                
                if(this.scannerStateRestoreStatusPoller !== null) {
                    clearInterval(this.scannerStateRestoreStatusPoller);
                }

            })
            .catch(err => {
                console.log(err);
            })
    }

    resetPersistedState = () => {
        let url = `/server/scano/1/api~hts~reset_persisted_state/`;
        get_response(url)
            .then(response => {
                if (response.status >= 200) {
                    this.setState({deletedPreviousData: true})
                    message.info("Successfully deleted previous data.")
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    resetPersistedQueue = () => {
        let url = `/server/scano/1/api~hts~reset_persisted_queue_state/`;
        get_response(url)
            .then(response => {
                if (response.status >= 200) {
                    this.setState({deletedPreviousData: true})
                    message.info("Successfully deleted queue data.")
                }
            })
            .catch(err => {
                console.log(err);
            })
    }

    resetPersistedStateModal = () => {
        const _this = this;
        Modal.confirm({
          title: 'Reset previous session data.',
          icon: null,
          content: [<Row>All previous preview data will be deleted.</Row>,<br></br>,<Row>Are you sure?</Row>],
          okText: 'Yes',
          cancelText: 'Cancel',
          onOk() {
            _this.resetPersistedState();
        },
        });
    }

    resetPersistedQueueStateModal = () => {
        const _this = this;
        Modal.confirm({
            title: 'Reset previous session queue data.',
            icon: null,
            content: [<Row>All previous queue data will be deleted.</Row>,<br></br>,<Row>Are you sure?</Row>],
            okText: 'Yes',
            cancelText: 'Cancel',
            onOk() {
                _this.resetPersistedQueue();
            },
        });
    }

    handleBarcodeChange = (e) => {
        let flag = this.state.takeAllBarcodes;
        this.setState({
            takeAllBarcodes: !flag
        });
    }

    handlePreviewChange = (e) => {
        let flag = this.state.queueAllSlidesForPreviews;
        this.setState({
            takeAllBarcodes: !flag,
            queueAllSlidesForPreviews: !flag
        });
    }

    handleScanChange = (e) => {
        let flag = this.state.queueAllSlidesForScans;
        this.setState({
            takeAllBarcodes: !flag,
            queueAllSlidesForPreviews: !flag,
            queueAllSlidesForScans: !flag
        });
    }



    render() {
        let disablePromptBtn = this.isPromptBtnDisabled(this.props.prompt);
        let textInfo = <Col></Col>
        let racks_table = [];
        let cassetteOnStage = ""
        if (this.props.cassetteOnStage) {
            let rack = this.props.cassetteOnStage.rack === 1 ? "L" : "R"
            let tray = this.props.cassetteOnStage.tray + 1
            cassetteOnStage = rack + tray;
        }
        this.renderRacksTable(racks_table);

        let _blockUI = this.props.c240LoaderState.show_loader || this.props.blockUI;
        let restoreStatusErroredOut = this.props.prompt === C240PromptType.OPEN_GATE_PROMPT && this.state.scannerStateRestoreStatus.msgType === "ERROR";

        return (
            // <div style={{padding: '5px'}}>
            <Row className="rounded-container load-slides-message-div" style={this.props.prompt === C240PromptType.REMOVED_TASKS_PROMPT ?{height: '800px', zIndex: 999}:{height: '500px', zIndex: 999}}>
                    <Col className="scan-workflow-init" span={24}>
                    <Spin spinning={_blockUI ? true : false}
                        style={{zIndex: 10}}
                        tip={this.props.prompt === C240PromptType.OPEN_GATE_PROMPT ?
                             "Opening the Gate"
                             : this.props.prompt === C240PromptType.CLOSE_GATE_PROMPT ?
                             "Closing Gate. It may take a minute." : null} size="large">
                    <Row style={{ fontSize: 20 }} className="arial-font">
                        <div>
                            <Row>
                                {/* {this.props.prompt.replace(/_/g," ")} */}
                                { this.props.prompt === C240PromptType.OPEN_GATE_PROMPT ? <Row style={{ fontWeight: 'bold' }}>GATE IS CURRENTLY CLOSED</Row> : null }
                                { this.props.prompt === C240PromptType.CLOSE_GATE_PROMPT ? <Row style={{ fontWeight: 'bold' }}>GATE IS CURRENTLY OPEN</Row> : null }
                            </Row>
                            <br />
                            <Row>
                            { this.props.prompt === C240PromptType.OPEN_GATE_PROMPT ?
                            <OpenGatePromptComponent
                                deletedPreviousData={this.state.deletedPreviousData}
                                resetPersistedQueueState={this.resetPersistedQueueStateModal}
                                restoreProgress={this.state.restoreProgress}
                                dataRestored={this.state.restoredPreviousData}
                                scannerStateRestoreStatus={this.state.scannerStateRestoreStatus} />
                            : null }
                            { this.props.prompt === C240PromptType.CLOSE_GATE_PROMPT ?
                                <Row className='close-gate-info-block'>
                                    {this.props.invalidCassettesLoaded ?
                                        <div style={{color: "red"}}>
                                            <Row>Please leave slot "<b>{cassetteOnStage}</b>" empty.</Row>
                                        <Row>The cassette from this slot is on stage for scanning.</Row>
                                        </div>
                                        : null
                                    }
                                    <Row>Close the Gate once you have inserted / replaced the slides.</Row>
                                    <Row>Closing the gate will resume any previously queued tasks for untouched slots.</Row>
                                    {/* <Row>Any inserted or replaced Cassettes will be auto queued for previews.</Row> */}
                                    <br/>
                                    <Row className='close-gate-checkbox-container'>
                                        {/*@YASHESH: REMOVING Capture Barcode Option for newer C240s*/}
                                        {/*<Row>*/}
                                        {/*<Checkbox*/}
                                        {/*    disabled={this.state.queueAllSlidesForPreviews || this.state.queueAllSlidesForScans}*/}
                                        {/*    onClick={(e) => this.handleBarcodeChange(e)}*/}
                                        {/*    style={{fontSize: 16, padding: "5px"}}*/}
                                        {/*    id="barcode-checkbox"*/}
                                        {/*    checked={this.state.takeAllBarcodes}*/}
                                        {/*>*/}
                                        {/*    Capture Barcode for all newly inserted/replaced cassettes.*/}
                                        {/*</Checkbox>*/}
                                        {/*</Row>*/}
                                        <Row>
                                        <Checkbox
                                            disabled={this.state.queueAllSlidesForScans}
                                            onClick={(e) => this.handlePreviewChange(e)}
                                            style={{fontSize: 16, padding: "5px"}}
                                            id="preview-checkbox"
                                            checked={this.state.queueAllSlidesForPreviews}
                                        >
                                            Capture Preview for all newly inserted/replaced cassettes.
                                        </Checkbox>
                                        </Row>
                                        <Row>
                                            <Checkbox
                                                onClick={(e) => this.handleScanChange(e)}
                                                id="scans-checkbox"
                                                style={{fontSize: 16, padding: "5px"}}
                                                checked={this.state.queueAllSlidesForScans}
                                                >
                                                Take Scans for all newly inserted/replaced cassettes.
                                            </Checkbox>
                                        </Row>
                                    </Row>
                                </Row>
                                : null }
                            { this.props.prompt === C240PromptType.REMOVED_TASKS_PROMPT ?
                                <Row>
                                    <Row>Highlighted slots were either emptied or replaced.</Row>
                                    <Row>For these slots, existing tasks before opening the gate have been removed from the Queue.</Row>
                                </Row>
                             : null }
                            </Row>
                            <br />
                            {/* {textInfo} */}
                            <Row  style={{paddingLeft: "30%",paddingRight: "30%"}} >
                            {racks_table}
                            </Row>
                            {/* { this.props.prompt === C240PromptType.REMOVED_TASKS_PROMPT ?
                                <Row>Any inserted or replaced Cassettes have automatically been queued for preview.</Row>
                             : null } */}
                            <Row>
                            </Row>
                        </div>
                    </Row>
                    {/*<br></br>*/}
                    <Row style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Tooltip title="Click here when done" placement="rightTop">
                            <Col
                                className="c240-promt-done-button"
                                style={disablePromptBtn ? { cursor: "not-allowed", opacity: "0.3" } : {}}
                                onClick={(e) => {if (disablePromptBtn) {return;} this.closePrompt(e)}}>
                                <Row style={{ color: "#26A65B" }}>
                                    <CheckCircleOutlined style={{ fontSize: 38, marginRight: "10px" }}/>
                                </Row>
                                <Row className="arial-font" style={{fontSize: "20px"}}>{
                                restoreStatusErroredOut ? "OK" :
                                this.props.prompt === C240PromptType.OPEN_GATE_PROMPT ? "Continue Queued Tasks" :
                                this.props.prompt === C240PromptType.CLOSE_GATE_PROMPT ? "Close Gate" :
                                "Proceed" }</Row>
                            </Col>
                        </Tooltip>
                    </Row>
                    </Spin>
                </Col>
            </Row>
            // </div>
        )
    }

    renderRacksTable(racks_table) {
        if (this.props.prompt === C240PromptType.REMOVED_TASKS_PROMPT) {
            // textInfo = this.props.removedtasks.map((cassette) => {
            //     return <Col span={5} >
            //     {`${this.taskTitle(cassette["taskType"])}R${cassette["rack"] === 0 ? 2 : cassette["rack"]}T${cassette["tray"]+1}S${cassette["slide"]+1}`}
            //     </Col>
            // })
            let listOfRemovedTasks = []
            this.props.removedtasks.map((cassette) => {
                listOfRemovedTasks.push("R" + cassette["rack"] + "T" + cassette["tray"] + "S" + cassette["slide"])
            })
            let listOfAffectedCassettes = [];
            this.props.removedtasks.map((cassette) => {
                if (!listOfAffectedCassettes.includes("R" + cassette["rack"] + "T" + cassette["tray"])) {
                    console.debug("affected cassette: " + "R" + cassette["rack"] + "T" + cassette["tray"]);
                    listOfAffectedCassettes.push("R" + cassette["rack"] + "T" + cassette["tray"]);
                }
            })
            let slots = [0, 1, 2, 3, 4, 5];
            for (let i = 1; i >= 0; i--) {
                let toolTipPosition = i === 0 ? "right" : "left";
                let thisrack = [];
                for (let j = 19; j >= 0; j--) {
                    const key = `R${i}T${j}`;
                    thisrack.push(
                        <Row key={key}>
                            <Card
                                className="zero-padded-ant-card-body"
                                bodyStyle={{padding: "4px !important"}}
                                bordered={true}
                                style={
                                    listOfAffectedCassettes.includes(key) ?
                                        {
                                            border: `solid red`,
                                            borderWidth: "3 px",
                                            padding: "2px !important",
                                            marginTop: "2px"
                                        } : {
                                            borderLeft: `solid #B0B0B0`,
                                            borderWidth: "3 px",
                                            padding: "2px !important",
                                            marginTop: "2px"
                                        }
                                }>
                                <Row>
                                    {/* <Tooltip placement={toolTipPosition} title={
                                    <div>
                                        <Row style={{ display: "flex"}}>
                                            <Col span={24}> {"Slot " + (i === 0 ? "R" : "L") + (j+1)} </Col>
                                        </Row>
                                    </div>} color="#2db7f5" > */}
                                    <div>
                                        <Col span={8} style={{fontSize: '0.7vw', paddingLeft: '0.4vw'}}>
                                            {(i === 0 ? "R" : "L") + (j + 1)}
                                        </Col>
                                    </div>
                                    {/* <div style={{ marginLeft:"15px"}}>
                                        {slots.map((value) => {return <Col key={value.toString()} span={2}>
                                            <InSlideState red={listOfRemovedTasks.includes((key+"S"+value))}></InSlideState>
                                        </Col>})}
                                    </div> */}
                                    {/* </Tooltip> */}
                                </Row>


                            </Card>

                        </Row>
                    );
                }
                racks_table.push(<Col key={`rack-${i}`} offset={0} style={{marginLeft: "4px"}}
                                      span={11}>{thisrack}</Col>);
            }

        }
    }
}

const mapStateToProps = (state) => {
    return {
        c240LoaderState: state.c240LoaderReducer,
        previews : state.previewStatusReducer,
    };
};

export default connect(mapStateToProps)(GatePrompt);